function updateCartPromo() {
  const cartTimer = document.querySelector(".cart-timer");
  const cartCode = document.querySelector(".cart-code");

  if(!cartTimer || !cartCode) {
    return;
  }

  const now = new Date();
  const minutes = now.getMinutes();
  const seconds = now.getSeconds();

  let lastTenMark = Math.floor(minutes / 10) * 10;
  if (lastTenMark === 0) {
    lastTenMark = 60;
  }
  
  const formattedMark = lastTenMark.toString().padStart(2, '0');
  const dynamicCode = `GETFAST${formattedMark}`;

  if (!cartCode.dataset.isCopied) {
    cartCode.textContent = dynamicCode;
  }

  const secondsPassed = (minutes % 10) * 60 + seconds;
  let secondsRemaining = 600 - secondsPassed;

  if (secondsRemaining === 600 && seconds > 0) {
      secondsRemaining = 0; 
  }

  const displayMinutes = Math.floor(secondsRemaining / 60);
  const displaySeconds = secondsRemaining % 60;
  
  const formattedTime = `${displayMinutes}:${displaySeconds.toString().padStart(2, '0')}`;

  cartTimer.textContent = formattedTime;

  if (!cartCode.dataset.listenerAttached) {
    cartCode.style.cursor = "pointer";
    cartCode.addEventListener("click", () => {
      if (cartCode.dataset.isCopied) return;
      
      const codeToCopy = cartCode.textContent;
      navigator.clipboard.writeText(codeToCopy).then(() => {
        cartCode.dataset.isCopied = "true";
        cartCode.textContent = "Kopiert!";
        
        setTimeout(() => {
          cartCode.removeAttribute("data-is-copied");
        }, 5000);
      });
    });
    cartCode.dataset.listenerAttached = "true";
  }
}

setInterval(updateCartPromo, 1000);

// setInterval(() => {
//     const rewardsContainer = document.querySelector('[data-testid="TieredRewardsProgressBar"]');
//     const targetSpan = document.querySelector('.current-tier');
//     const preUnlockContainer = document.querySelector('[data-testid="TieredRewardsPreUnlockText"]');

//     if (rewardsContainer && targetSpan) {
//         const fulfilledLabels = rewardsContainer.querySelectorAll('.amp-sc__rewards-label--fulfilled');
        
//         if (fulfilledLabels.length > 0) {
//             const latestDiscount = fulfilledLabels[fulfilledLabels.length - 1].textContent.trim();
//             const message = "Gratulation! Du hast extra " + latestDiscount + " erhalten!";

//             if (targetSpan.textContent !== message) {
//                 targetSpan.textContent = message;
//             }
//         } else if (preUnlockContainer) {
//             const rawText = preUnlockContainer.textContent;
//             preUnlockContainer.style.display = "none";
//             const amountMatch = rawText.match(/€\d+\,\d+/);
//             const rewardMatch = rawText.match(/\d+%\s*Rabatt/);

//             if (amountMatch && rewardMatch) {
//                 const amount = amountMatch[0];
//                 const reward = rewardMatch[0];
//                 const message = "Noch " + amount + " bis " + reward;

//                 if (targetSpan.textContent !== message) {
//                     targetSpan.textContent = message;
//                 }
//             }
//         }
//     }

// }, 1000);